<template>
    <svg width="1.2rem" height="1.2rem" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.75 5.13393C10.4167 5.51883 10.4167 6.48108 9.75 6.86598L2.25 11.1961C1.58333 11.581 0.75 11.0999 0.75 10.3301L0.75 1.66983C0.75 0.900026 1.58333 0.418901 2.25 0.803801L9.75 5.13393Z"
            fill="#F9F9F9" />
        <line x1="13.75" y1="1.5" x2="13.75" y2="10.5" stroke="white" stroke-linecap="round" />
    </svg>
</template>